"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var accepted_file_types_1 = __importDefault(require("./accepted_file_types"));
var getEntriesFromDirectory = function (directoryEntry) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                return directoryEntry.createReader().readEntries(resolve, reject);
            })];
    });
}); };
var getFileFromFileEntry = function (fileEntry) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, new Promise(function (resolve, reject) { return fileEntry.file(resolve, reject); })];
}); }); };
var getFilesFromFileSystemEntries = function (entries) { return __awaiter(void 0, void 0, void 0, function () {
    var result, entry, file, entriesFromDirectory, files, e_1_1;
    var _a, entries_1, entries_1_1;
    var _b, e_1, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                result = [];
                _e.label = 1;
            case 1:
                _e.trys.push([1, 10, 11, 16]);
                _a = true, entries_1 = __asyncValues(entries);
                _e.label = 2;
            case 2: return [4 /*yield*/, entries_1.next()];
            case 3:
                if (!(entries_1_1 = _e.sent(), _b = entries_1_1.done, !_b)) return [3 /*break*/, 9];
                _d = entries_1_1.value;
                _a = false;
                entry = _d;
                if (!entry.isFile) return [3 /*break*/, 5];
                return [4 /*yield*/, getFileFromFileEntry(entry)];
            case 4:
                file = _e.sent();
                result.push(file);
                return [3 /*break*/, 8];
            case 5:
                if (!entry.isDirectory) return [3 /*break*/, 8];
                return [4 /*yield*/, getEntriesFromDirectory(entry)];
            case 6:
                entriesFromDirectory = _e.sent();
                return [4 /*yield*/, getFilesFromFileSystemEntries(entriesFromDirectory)];
            case 7:
                files = _e.sent();
                files.forEach(function (file) { return result.push(file); });
                _e.label = 8;
            case 8:
                _a = true;
                return [3 /*break*/, 2];
            case 9: return [3 /*break*/, 16];
            case 10:
                e_1_1 = _e.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 16];
            case 11:
                _e.trys.push([11, , 14, 15]);
                if (!(!_a && !_b && (_c = entries_1.return))) return [3 /*break*/, 13];
                return [4 /*yield*/, _c.call(entries_1)];
            case 12:
                _e.sent();
                _e.label = 13;
            case 13: return [3 /*break*/, 15];
            case 14:
                if (e_1) throw e_1.error;
                return [7 /*endfinally*/];
            case 15: return [7 /*endfinally*/];
            case 16: return [2 /*return*/, result];
        }
    });
}); };
var getFilesFromDataTransfer = function (dataTransfer) { return __awaiter(void 0, void 0, void 0, function () {
    var entries, files;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!dataTransfer.items) return [3 /*break*/, 2];
                entries = __spreadArray([], __read(dataTransfer.items), false).map(function (item) { return item.webkitGetAsEntry(); });
                return [4 /*yield*/, getFilesFromFileSystemEntries(entries)];
            case 1:
                files = _a.sent();
                return [2 /*return*/, files];
            case 2: 
            // backwards compatibility
            return [2 /*return*/, __spreadArray([], __read(dataTransfer.files), false)];
        }
    });
}); };
var DropArea = /** @class */ (function () {
    function DropArea(_a) {
        var container = _a.container, inputAccept = _a.inputAccept, onUploadFiles = _a.onUploadFiles;
        var _this = this;
        this.onDrop = function (e) {
            var dragEvent = e;
            _this.container.classList.remove("dff-dropping");
            dragEvent.preventDefault();
            dragEvent.stopPropagation();
            var uploadFiles = function () { return __awaiter(_this, void 0, void 0, function () {
                var files, acceptedFiles, error_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            if (!dragEvent.dataTransfer) return [3 /*break*/, 2];
                            return [4 /*yield*/, getFilesFromDataTransfer(dragEvent.dataTransfer)];
                        case 1:
                            files = _a.sent();
                            acceptedFiles = files.filter(function (file) {
                                return _this.acceptedFileTypes.isAccepted(file.name);
                            });
                            this.onUploadFiles(acceptedFiles);
                            _a.label = 2;
                        case 2: return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            console.error(error_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
            void uploadFiles();
        };
        this.container = container;
        this.onUploadFiles = onUploadFiles;
        this.acceptedFileTypes = new accepted_file_types_1.default(inputAccept);
        container.addEventListener("dragenter", function () {
            container.classList.add("dff-dropping");
        });
        container.addEventListener("dragleave", function () {
            container.classList.remove("dff-dropping");
        });
        container.addEventListener("dragover", function (e) {
            container.classList.add("dff-dropping");
            e.preventDefault();
        });
        container.addEventListener("drop", this.onDrop);
    }
    return DropArea;
}());
exports.default = DropArea;
